export const rateText = {
  discipline: "انضباط اداری",
  performance: "عملکرد سازمان در مجموع",
  report: "گزارش دهی به حامیان",
  responsiveness: "شیوه پاسخگویی",
  service_quality: "کیفیت خدمات",
  transparency: "شفافیت مالی",
};
